import { To } from "history";
import { useNavigate as useReactRouterNavigate } from "react-router";

type NavigateHook = (route: -1 | To) => void;

export function useNavigate(): NavigateHook {
  const navigate = useReactRouterNavigate();
  return (route: -1 | To) => {
    if (route === -1) {
      window.history.state.idx > 0 ? navigate(-1) : navigate("/");
    } else {
      navigate(route);
    }
  };
}
